/**
 * Un poco de configuracion para `VuexPersistence`
 */
export default {
  storageKey: 'validator_storage_keep'
}